import React from 'react'
import { LanguageConstants } from '../constants/LanguageConstants'

function AddressChangeMessage(props:any) {
    const handleChangeAddress =()=>{
        props?.setAddressChangeShow(true)
        props?.handleClose()
    }
  return (
    <>
      <div className="modal fade com-modal short-modal show" id="changeAddressModal" aria-labelledby="changeAddressModalLabel" aria-hidden="true" style={{display: "block"}} >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="changeAddressModalLabel">{LanguageConstants?.CHANGE_ADDRESS}</h5>
                            <button onClick={()=>props?.handleClose()}  type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="icon-close-square" /></button>
                        </div>
                        <div className="modal-body pb-0 text-start">
                            <p className="modal-para mt-2">{LanguageConstants?.CHANGE_ADDRESS_DES}</p>
                        </div>
                        <div className="modal-footer">
                            <button onClick={()=>handleChangeAddress()} className="round-btn m-0 w-100" >{LanguageConstants?.COUNTINUE}</button>
                        </div>
                    </div>
                </div>
      </div>
    </>
  )
}

export default AddressChangeMessage